import React from 'react';
import classnames from 'classnames';
import { withTranslation } from 'react-i18next';
import Button from '../../Button';
import TextTooltipOnHover from '../../Tooltip/TextTooltipOnHover';
import LockIcon from '../../Icons/Lock';
import { IconSize } from '../../Icons/IconWrap';
import s from '../FolderCard.scss';
var FolderCardFooter = function (_a) {
    var folder = _a.folder, subfolders = _a.subfolders, isLocked = _a.isLocked, statsClassName = _a.statsClassName, withViewAllButton = _a.withViewAllButton, withCommentsCount = _a.withCommentsCount, children = _a.children, t = _a.t;
    var totalDeviationCount = folder.size +
        (subfolders
            ? subfolders.reduce(function (prevValue, subfolder) { return prevValue + subfolder.size; }, 0)
            : 0);
    return (React.createElement("div", { className: s['bottom-content'] },
        React.createElement("div", { className: s['description'] },
            React.createElement("div", { className: s['name'] },
                React.createElement("span", null, folder.name),
                isLocked && (React.createElement(TextTooltipOnHover, { className: s['lock-icon'], tooltipText: t('folderCard.locked'), positionFixed: true, width: 220 },
                    React.createElement(LockIcon, { size: IconSize.MEDIUM, condensed: true })))),
            React.createElement("div", { className: classnames(s['stats'], statsClassName) },
                React.createElement("div", { className: s['artworks-count'] }, t('folderCard.stats.artworks', {
                    count: totalDeviationCount,
                })),
                withCommentsCount && (React.createElement("div", { className: s['comments-count'] }, t('folderCard.stats.comments', {
                    count: folder.commentCount,
                }))))),
        withViewAllButton && (React.createElement(Button, { view: "b14", height: "medium", className: s['view-all'] }, t('folderCard.viewAll'))),
        children));
};
export default withTranslation()(FolderCardFooter);
//# sourceMappingURL=FolderCardFooter.js.map